export const TRANSLATION_LENGTH_WARNING_THRESHOLD = 1.5; // 50% longer

export function isTranslationTooLong(originalLength, translationLength) {
	if (!originalLength || !translationLength) return false;
	return translationLength > originalLength * TRANSLATION_LENGTH_WARNING_THRESHOLD;
}

export const triggerResize = () => window.EUROVIZ_IFRAMES_CHECK?.();

export function isTrustedScriptUrl(url) {
	try {
		return new URL(url, location.origin).origin === new URL(API_BASE_URL, location.origin).origin;
	} catch {
		return false;
	}
}

export function loadScript(url) {
	const p = new Promise((resolve, reject) => {
		const script = document.createElement("script");
		script.onload = () => {
			// console.log(`loaded script: ${url}`);
			resolve();
		};
		script.onerror = () => {
			console.error(`failed to load script: ${url}`);
			reject();
		};
		script.src = url;
		document.getElementsByTagName("head")[0].appendChild(script);
	});
	return p;
}

export function deepcopy(x) {
	return JSON.parse(JSON.stringify(x));
}

export function random() {
	return (Math.random() + 1).toString(36).substring(7);
}

export function sortAlphabetically(a, b, key = "id") {
	if (a[key] < b[key]) return -1;
	if (b[key] < a[key]) return 1;
	return 0
}

export function optionsToObject(options) {
	return options.reduce((obj, item) => ({ ...obj, [item.id]: item.selected }), {})
}

export function translationsToObject(translations) {
	return translations.filter(x => x.modified).reduce((obj, item) => ({ ...obj, [item.string]: item.input || item.string }), {})
}

export function transformStringToInputObject(string) {
	return {
			original: string,
			modified: false,
			selected: deepcopy(string),
	};
}

export const toObject = (arr, idKey = "id") => arr.reduce((obj, item) => ({ ...obj, [item[idKey]]: item }), {});


export function flattenOptions(options) {
	if (Array.isArray(options)) return options;
	return Object.values(options).flat();
}

export function isGroupedOptions(options) {
	return options != null && typeof options === 'object' && !Array.isArray(options);
}

// for use in query params
export function encodeTranslations(translations) {
  let out = {};
  Object.keys(translations).forEach((k) => {
    if (translations[k] !== k) out[k] = translations[k];
  });
  out = JSON.stringify(out);
  out = encodeURIComponent(out);
  //out = out.replace(/%22/g, '"');
  //out = out.replace(/%20/g, ' ');
  return out;
}
